import { gql } from '@apollo/client';

export const healthOrderStatusQueryApollo = gql`
  query OrderStatus($orderId: UUID!) {
    orderStatus(orderId: $orderId) {
      orderId
      status
      underwritingResultStatus
      errors {
        message
        code
      }
    }
  }
`;
